export const BASE_URL = `/:country/:language/orders${import.meta.env.VITE_URL_SUFFIX ? `/:${import.meta.env.VITE_URL_SUFFIX}` : ''}`;
